import React, {
  useMemo,
  createContext,
  useContext,
  useEffect,
  useCallback,
  useRef
} from 'react';
import io from 'socket.io-client';
import store from '../store';
import {
  addMessageUnansweredConversation,
  addUnAnsweredConversation,
  removeUnAnsweredConversation,
  addTagsUnAnsweredConversationInAttendance
} from '../store/action/unanswered-convertations-action';
import {
  removeAnsweredConversation,
  addMessageAnsweredConversation,
  addAnsweredConversation,
  addStatusMetricsOfConversation,
  addTagsAnsweredConversationInAttendance
} from '../store/action/answered-conversations-action';
import * as yup from 'yup';

import {
  addMessageConversationInAttendance,
  checkRemoveConversationInAttendance,
  deleteMessageConversationInAttendance,
  updateStatusMessageConversationInAttendance,
  updateWhatsappMessageIdConversationInAttendance,
  addTagsConversationInAttendance
} from '../store/action/conversation-in-attendance-action';
import { useChat } from './useChat';
import { getDailyClosedChat } from '../store/action/update-chat-metrics-action';
import { updateAllMonitoringQueueChat } from 'store/action/monitoring-chat-actions';
import { updateMonitoringQueueChat } from 'store/action/monitoring-chat-actions';
import FlexChatIntegrationService from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration/index.js';
import {
  saveObjectToLocalStorage,
  loadObjectFromLocalStorage
} from 'utils/fuctions/localStorage';
import { LOCAL_STORAGE_KEYS } from 'utils/fuctions/localStorage';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import {
  useSocketEvents,
  useSocketLifecycle,
  wrapSocketWithGlobalLoader
} from './socket-utils';
import { useQueueChatPauseContext } from './useQueuePauseChatServicePanel';

const useSocketConversationChatTsContext = createContext();

export const EVENTS_EMIT = {
  CHAT_TRANSFER_BOT_TO_ATTENDANCE:
    'conversa_transferida_pelo_bot_para_atendente',
  TRANSFER_CHAT_TO_QUEUE: 'transferir_conversa',
  TRANSFER_MULTIPLE_CHAT_TO_QUEUE: 'transferir_multiplas_conversas',
  CUSTOMER_SENDING_MESSAGE: 'cliente_enviou_mensagem',
  DELETE_MESSAGE_FROM_CHAT: 'delete_message_from_chat',
  AMD_SENDING_WHISPER: 'adm_enviou_sussurro',
  CHAT_TRANSFERRED: 'conversa_transferida',
  CHAT_FINISHED: 'conversa_encerrada',
  DELETE_CHAT_FROM_QUEUE: 'remove_conversa_fila',
  SHOW_POPUP_TO_AGENT: 'show_popup_to_agent',
  ATTENDANT_FINISH_CHAT: 'encerra_conversa_atendente',
  FINISH_MULTIPLE_CONVERSATION: 'encerrar_multiplas_conversas',
  EVENT_OF_MESSAGE: 'evento_de_mensagem',
  CHANGE_MESSAGE_WHATSAPP_ID: 'change_message_whatsapp_id',

  ADD_CHAT_ON_HOLD: 'ADD_CHAT_ON_HOLD',
  REMOVE_CHAT_ON_HOLD: 'REMOVE_CHAT_ON_HOLD',
  ADD_CHAT_IN_AGENT: 'ADD_CHAT_IN_AGENT',
  REMOVE_CHAT_FROM_AGENT: 'REMOVE_CHAT_FROM_AGENT',
  ANSWERED_CHAT: 'atender_conversa',
  UPDATE_CONFIG_SIGNAL_CONVERSATION: 'UPDATE_CONFIG_SIGNAL_CONVERSATION',
  UPDATE_METRICS_OF_SERVICE_PANEL: 'UPDATE_METRICS_OF_SERVICE_PANEL',

  GET_ALL_DATA_MONITORING_SYNTHETIC_CHAT:
    'GET_ALL_DATA_MONITORING_SYNTHETIC_CHAT',
  UPDATE_ALL_MONITORING_SYNTHETIC_CHAT: 'UPDATE_ALL_MONITORING_SYNTHETIC_CHAT',
  UPDATE_MONITORING_SYNTHETIC_CHAT: 'UPDATE_MONITORING_SYNTHETIC_CHAT',

  JOIN_IN_MONITORING_QUEUE_CHAT: 'JOIN_IN_MONITORING_QUEUE_CHAT',
  JOINED_IN_MONITORING_QUEUE_CHAT: 'JOINED_IN_MONITORING_QUEUE_CHAT',
  UPDATE_MONITORING_QUEUE_CHAT_DATA: 'UPDATE_MONITORING_QUEUE_CHAT_DATA',
  LEAVE_MONITORING_QUEUE_CHAT: 'LEAVE_MONITORING_QUEUE_CHAT',
  ERROR_MONITORING_QUEUE_CHAT: 'ERROR_MONITORING_QUEUE_CHAT',
  TOGGLE_CHAT_AGENT_PAUSE: 'TOGGLE_CHAT_AGENT_PAUSE',

  GET_MONITORING_UNIFIED_INITIAL_DATA: 'GET_MONITORING_UNIFIED_INITIAL_DATA',
  UPDATE_MONITORING_UNIFIED_INITIAL_DATA:
    'UPDATE_MONITORING_UNIFIED_INITIAL_DATA',
  UPDATE_MONITORING_UNIFIED_TIME_AVERAGES:
    'UPDATE_MONITORING_UNIFIED_TIME_AVERAGES',
  UPDATE_MONITORING_UNIFIED_AVERAGE_SURVEY:
    'UPDATE_MONITORING_UNIFIED_AVERAGE_SURVEY',

  GET_AGENTS_LOGGED_IN_CHAT_QUEUES: 'GET_AGENTS_LOGGED_IN_CHAT_QUEUES',
  UPDATE_AGENTS_LOGGED_IN_CHAT_QUEUES: 'UPDATE_AGENTS_LOGGED_IN_CHAT_QUEUES',
  GET_AGENTS_LOGGED_IN_SYSTEM: 'GET_AGENTS_LOGGED_IN_SYSTEM', // Solicita todos os agentes que estão online do flexUC (Equivalente a: lista_atendentes_logados)
  UPDATE_AGENTS_LOGGED_IN_SYSTEM: 'UPDATE_AGENTS_LOGGED_IN_SYSTEM', // Retorna informações de todos os agentes logados, informação de quando um agente logou no sistema, informação quando um agente saiu do sistema (Incluindo fechamento de aba ou perca de conexão do socket)

  LOGIN_AGENT_SYSTEM: 'LOGIN_AGENT_SYSTEM', // Deve ser emitido quando um agente loga no sistema (Equivalente ao atendente_login)
  LOGOUT_AGENT_SYSTEM: 'LOGIN_AGENT_SYSTEM' // Deve ser emitido quando um agente desloga no sistema (Equivalente a atendente_logoff e atendente_logoff_ativo)
};

export function ConversationChatTsConnectionSocketForMonitoringProvider({
  children
}) {
  const conversationInAttendance = useSelector(
    (state) => state.conversationInAttendance
  );

  const conversationInAttendanceRef = useRef(conversationInAttendance);

  useEffect(() => {
    conversationInAttendanceRef.current = conversationInAttendance;
  }, [conversationInAttendance]);

  const { removeChatSavedById } = useChat();
  const { getInitialValuesQueueChatPause } = useQueueChatPauseContext();

  const getMaxPullChatConfigFromLocalStorage = useCallback(() => {
    const config = loadObjectFromLocalStorage(
      LOCAL_STORAGE_KEYS.CONFIG_CHAT_MAX_PULL_CHAT
    );
    return {
      active: config?.active ?? false,
      maxChats: config?.maxPullChat ?? 1
    };
  }, []);

  const socketChatTS = useMemo(
    () =>
      wrapSocketWithGlobalLoader(
        io(process.env.REACT_APP_PROXY_URL, {
          path: '/flex-chat-integration-socket',
          transports: ['websocket'],
          upgrade: false,
          query: { token: localStorage.getItem('token') },
          reconnection: true,
          reconnectionDelay: 1000
        })
      ),
    []
  );

  const emitEventAnsweredChat = useCallback(
    async ({ chatId, socketId }) => {
      return new Promise((resolve, reject) => {
        socketChatTS.emit(
          EVENTS_EMIT.ANSWERED_CHAT,
          {
            atendente: {
              nome: localStorage.getItem('name'),
              login: localStorage.getItem('login'),
              id_socket: socketId
            },
            id: chatId
          },
          (response) => {
            if (response?.success) {
              resolve(response);
            } else {
              console.error(
                'Failed to answer chat via socket:',
                response?.error
              );
              reject(
                new Error(response?.error || 'Failed to answer chat via socket')
              );
            }
          }
        );
      });
    },
    [socketChatTS]
  );

  useSocketLifecycle(socketChatTS, {
    onConnect: () => {
      console.log('Connected to chat integration socket');
      const queuesUser = JSON.parse(localStorage.getItem('queues'));
      let teamUser = [];
      if (
        localStorage.getItem('teams') !== null ||
        localStorage.getItem('teams') !== undefined
      ) {
        teamUser = JSON.parse(localStorage.getItem('teams'));
      }
      const queuesName = queuesUser.map((queue) => queue.name);
      const data = {
        login: localStorage.getItem('login'),
        name: localStorage.getItem('name'),
        socket_id: socketChatTS.id,
        nickname: localStorage.getItem('nickname'),
        queues: queuesName,
        teams: teamUser || [],
        pin_code: localStorage.getItem('pin_code')
      };

      socketChatTS.emit(EVENTS_EMIT.LOGIN_AGENT_SYSTEM, data);
    },
    onDisconnect: () => {
      console.log('Disconnected from chat integration socket');
      socketChatTS.connect();
    },
    onConnectError: (error) => {
      console.error('Connection error:', error);
      socketChatTS.connect();
    }
  });

  useEffect(() => {
    if (socketChatTS.sendBuffer.length > 0) {
      console.warn('Socket has pending messages in the buffer');
    }
    socketChatTS.connect();
  });

  useSocketEvents(socketChatTS, {
    [EVENTS_EMIT.UPDATE_ALL_MONITORING_SYNTHETIC_CHAT]: async (data) => {
      await store.dispatch(updateAllMonitoringQueueChat(data));
    },
    [EVENTS_EMIT.UPDATE_MONITORING_SYNTHETIC_CHAT]: async (data) => {
      await store.dispatch(updateMonitoringQueueChat(data));
      await store.dispatch(
        addStatusMetricsOfConversation({
          chatId: data?.chatId,
          statusOfChat: data?.statusMetrics,
          withResponseAgent: data?.withResponseAgent
        })
      );
    },
    [EVENTS_EMIT.ADD_CHAT_ON_HOLD]: async (chat) => {
      await store.dispatch(addUnAnsweredConversation(chat));
      await store.dispatch(removeAnsweredConversation(chat?.id || chat?._id));
      await store.dispatch(
        checkRemoveConversationInAttendance(chat?.id || chat?._id)
      );
    },
    [EVENTS_EMIT.REMOVE_CHAT_FROM_AGENT]: async (chatId) => {
      await store.dispatch(removeUnAnsweredConversation(chatId));
      await store.dispatch(removeAnsweredConversation(chatId));
      await store.dispatch(checkRemoveConversationInAttendance(chatId));
      removeChatSavedById(chatId);
    },
    [EVENTS_EMIT.REMOVE_CHAT_ON_HOLD]: async (chatId) => {
      await store.dispatch(removeUnAnsweredConversation(chatId));
    },
    [EVENTS_EMIT.ADD_CHAT_IN_AGENT]: async (chat) => {
      await store.dispatch(addAnsweredConversation(chat));
    },
    [EVENTS_EMIT.CHAT_TRANSFER_BOT_TO_ATTENDANCE]: async (data) => {
      await store.dispatch(addAnsweredConversation(data.conversa));
    },
    [EVENTS_EMIT.CUSTOMER_SENDING_MESSAGE]: async (data) => {
      data.mensagem = { hora_da_mensagem: new Date(), ...data.mensagem };

      await store.dispatch(
        addMessageConversationInAttendance(data.mensagem, data.idDaConversa)
      );
      await store.dispatch(
        addMessageAnsweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );

      await store.dispatch(
        addMessageUnansweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );
    },
    [EVENTS_EMIT.CHANGE_MESSAGE_WHATSAPP_ID]: (payload) => {
      store.dispatch(updateWhatsappMessageIdConversationInAttendance(payload));
    },
    [EVENTS_EMIT.EVENT_OF_MESSAGE]: async (eventMessage) => {
      await store.dispatch(
        updateStatusMessageConversationInAttendance(eventMessage)
      );

      if (eventMessage?.status === 'sent' && eventMessage?.metaMessageId) {
        store.dispatch(
          updateWhatsappMessageIdConversationInAttendance({
            mid: eventMessage.mid,
            id_mensagem_whatsapp: eventMessage.metaMessageId
          })
        );
      }
    },
    [EVENTS_EMIT.DELETE_MESSAGE_FROM_CHAT]: async (data) => {
      await store.dispatch(deleteMessageConversationInAttendance(data));
    },
    [EVENTS_EMIT.AMD_SENDING_WHISPER]: async (data) => {
      data.mensagem = { hora_da_mensagem: new Date(), ...data.mensagem };
      await store.dispatch(
        addMessageConversationInAttendance(data.mensagem, data.idDaConversa)
      );
      await store.dispatch(
        addMessageAnsweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );
    },
    CONTACT_UPDATE_TAG: async (data) => {
      await store.dispatch(addTagsConversationInAttendance(data));
      await store.dispatch(addTagsAnsweredConversationInAttendance(data));
      await store.dispatch(addTagsUnAnsweredConversationInAttendance(data));
    },
    [EVENTS_EMIT.CHAT_TRANSFERRED]: (data) => {
      let idDaConversa = data.id ?? data._id;
      store.dispatch(removeAnsweredConversation(data));
      store.dispatch(checkRemoveConversationInAttendance(idDaConversa));
    },
    [EVENTS_EMIT.UPDATE_CONFIG_SIGNAL_CONVERSATION]: async (data) => {
      window.localStorage.setItem(
        'configSignalConversation',
        JSON.stringify(data)
      );
    },
    [EVENTS_EMIT.UPDATE_METRICS_OF_SERVICE_PANEL]: async (data) => {
      store.dispatch(getDailyClosedChat(data));
    },
    [EVENTS_EMIT.UPDATE_CONFIG_CHAT_PULL_CHAT]: (data) => {
      if ('active' in data && 'maxPullChat' in data)
        saveObjectToLocalStorage(
          LOCAL_STORAGE_KEYS.CONFIG_CHAT_MAX_PULL_CHAT,
          data
        );
      else {
        toast.warn(
          `Não foi possível atualizar as configurações de limite de resgate de conversas.`,
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      }
    },
    // Atualiza o estado das filas na barra superior, no ícone de chat
    [EVENTS_EMIT.UPDATE_AGENTS_LOGGED_IN_CHAT_QUEUES]: () => {
      getInitialValuesQueueChatPause();
    }
  });

  const emitEventTransferChatToQueue = ({
    chatId,
    queueId,
    subject,
    observation,
    sector
  }) => {
    socketChatTS.emit(EVENTS_EMIT.TRANSFER_CHAT_TO_QUEUE, {
      chatId,
      queueId,
      subject,
      observation,
      sector,
      responsibleForTransferred: {
        name: localStorage.getItem('name'),
        login: localStorage.getItem('login')
      }
    });
  };

  const transferMultipleChatsSchema = yup.object({
    chatIds: yup
      .array()
      .of(yup.string().required())
      .required('chatIds é obrigatório'),
    socketAgent: yup.string().nullable().defined(),
    destinationQueueId: yup.number().optional(),
    destinationAgentLogin: yup.string().optional(),
    responsibleForTransferred: yup
      .object({
        name: yup.string().required('Nome do responsável é obrigatório'),
        login: yup.string().required('Login do responsável é obrigatório')
      })
      .required()
  });

  const emitEventTransferMultipleChatsToQueue = (data) => {
    const validation = transferMultipleChatsSchema.safeValidateSync(data);

    if (!validation.success) {
      console.error('Falha na validação dos dados:', validation.error);
      toast.error('Dados de transferência inválidos');
      return;
    }

    FlexChatIntegrationService.postTransferManyChat(validation.data)
      .then((res) => {
        toast.success(res?.message ?? 'Conversas transferidas com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch((error) => {
        console.log({ error });
        toast.error('Não foi possível transferir as conversas', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const emitEventFinishChat = async ({ chatId, body }) => {
    return new Promise((resolve, reject) => {
      socketChatTS.emit(
        EVENTS_EMIT.ATTENDANT_FINISH_CHAT,
        {
          id: chatId,
          body: {
            ...body,
            loginUserRequest: localStorage.getItem('login'),
            nameUserRequest: localStorage.getItem('name'),
            token: localStorage.getItem('token')
          }
        },
        (response) => {
          if (response?.success) {
            resolve(response);
          } else {
            console.error('Failed to finish chat via socket:', response?.error);
            reject(
              new Error(response?.error || 'Failed to finish chat via socket')
            );
          }
        }
      );
    });
  };

  const emitEventFinishMultipleChats = ({ chatIds, body }) => {
    const DTO = {
      ...body,
      loginUserRequest: localStorage.getItem('login'),
      nameUserRequest: localStorage.getItem('name'),
      token: localStorage.getItem('token')
    };

    socketChatTS.emit(EVENTS_EMIT.FINISH_MULTIPLE_CONVERSATION, {
      chatIds,
      body: DTO
    });
  };

  const emitEventGetAllDataMonitoringQueueChat = () => {
    socketChatTS.emit(EVENTS_EMIT.GET_ALL_DATA_MONITORING_SYNTHETIC_CHAT, {});
  };

  return (
    <>
      <useSocketConversationChatTsContext.Provider
        value={{
          socketChatTS,
          emitEventTransferChatToQueue,
          emitEventTransferMultipleChatsToQueue,
          emitEventFinishMultipleChats,
          emitEventFinishChat,
          emitEventAnsweredChat,
          emitEventGetAllDataMonitoringQueueChat,
          getMaxPullChatConfigFromLocalStorage
        }}
      >
        {children}
      </useSocketConversationChatTsContext.Provider>
    </>
  );
}

export function useSocketConversationChatTs() {
  const context = useContext(useSocketConversationChatTsContext);
  return context;
}
